export enum CeaseMedicationReason {
  AdverseReaction = "ADV"
}
